import { useMutation } from '@apollo/client';

import type {
  LoginCustomerMutation,
  LoginCustomerMutationVariables,
} from '@/account/app/components/Login/graphql';
import { loginCustomerMutation } from '@/account/app/components/Login/graphql';
import { GraphQLEndpoints } from '@/account/graphql/constants';

import type { ApolloError } from '@apollo/client';

interface UseAuthGraphqlLoginSubmitArgs {
  onCompleted: (data: LoginCustomerMutation) => void;
  onError: (error: ApolloError) => void;
}

export function useAuthGraphqlLoginSubmit({
  onCompleted,
  onError,
}: UseAuthGraphqlLoginSubmitArgs) {
  const [login] = useMutation<
    LoginCustomerMutation,
    LoginCustomerMutationVariables
  >(loginCustomerMutation, {
    context: {
      endpoint: GraphQLEndpoints.AUTH,
    },
    onError,
    onCompleted,
  });
  const callLogin = (
    email: string,
    password: string,
    challengeToken: string | null = null
  ) => login({ variables: { input: { email, password, challengeToken } } });
  return callLogin;
}
